// extracted by mini-css-extract-plugin
export default {"table_wrapper":"table_table_wrapper__9Yfok"};